var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dy-dialog",
    {
      attrs: {
        width: "70%",
        title: "选择房屋",
        "confirm-title": "确定",
        "show-confirm": _vm.multiple
          ? !!_vm.selectRows.length
          : !!_vm.selectRow,
        "append-to-body": "",
      },
      on: { onConfirm: _vm.handleSelected, onClose: _vm.handleClose },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("dy-main-container", {
        staticClass: "select-asset-dialog",
        attrs: { "hide-top-menu": "" },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("DyOrgManagement", {
                  ref: "leftTreeRef",
                  attrs: {
                    "table-list-api": _vm.api.getAssetTree,
                    "data-path": "data",
                    width: _vm.dividerOption.leftAsideWidth,
                    "table-columns": _vm.tableColumns,
                  },
                  on: { onchange: _vm.handleOrgSelected },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c("avue-crud", {
                  ref: "crud",
                  attrs: {
                    page: _vm.page,
                    data: _vm.tableList,
                    "table-loading": _vm.tableLoading,
                    option: _vm.crudOption,
                    search: _vm.searchForm,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "on-load": _vm.getList,
                    "search-change": _vm.searchChange,
                    "row-click": _vm.rowClick,
                    "update:search": function ($event) {
                      _vm.searchForm = $event
                    },
                    "selection-change": _vm.selectionChange,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "radio",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: row.$index },
                              model: {
                                value: _vm.selectRowIndex,
                                callback: function ($$v) {
                                  _vm.selectRowIndex = $$v
                                },
                                expression: "selectRowIndex",
                              },
                            },
                            [_vm._v(" ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }